export default (function (v) { return v; });
//# sourceMappingURL=identity.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/esm/identity.js
// module id = 482
// module chunks = 3